// extracted by mini-css-extract-plugin
export default {"GuideImg":"Guide_GuideImg__dUgkF"};